import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { getSeoTypes, handleUpdateFields } from "store/cms/pages/seo/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import { log } from "console";

interface PagesSeoMainTab {
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
}

const PagesSeoMainTab: React.FC<PagesSeoMainTab> = ({
  fieldErrors,
  clearFieldError,
  readOnly,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const types = useAppSelector((store) => store.cmsSeo.types);
  const isTypesFetched = useAppSelector((store) => store.cmsSeo.isTypesFetched);
  const payload = useAppSelector((store) => store["cmsSeo"].payload);
  const isRtp = ["bo.rtp.bet", "backoffice-staging.rtp.bet"].includes(
    window.location.hostname,
  );
  const availableTypes = types.filter(
    ({ value }) => !isRtp || String(value).toLowerCase() !== "lobby",
  );

  const handleData = (
    key: string,
    value: string | boolean | number,
    img?: File | null,
  ) => {
    // @ts-ignore
    dispatch(handleUpdateFields({ [key]: img ?? value }));
  };

  useEffect(() => {
    if (!isTypesFetched) {
      dispatch(getSeoTypes());
    }
  }, []);

  return (
    <div className="pages-form-content mt-14">
      <div className="row">
        <div className="pages-form-box--item">
          <InnerInput
            value={payload?.title ?? ""}
            placeholder={t("enterTitle")}
            label={t("title")}
            type="text"
            id="pages-title"
            onChange={(e) => {
              handleData("title", e);
              clearFieldError("title");
            }}
            hasError={Boolean(fieldErrors?.["title"])}
            disabled={readOnly}
          />
        </div>
        <div className="pages-form-box--item">
          <DefaultDropdown
            value={payload?.type ?? ""}
            placeholder={t("chooseType")}
            label={t("type")}
            options={availableTypes}
            onSelect={(val) => {
              handleData("type", val);
              clearFieldError("type");
            }}
            hasError={Boolean(fieldErrors?.["type"])}
            disabled={readOnly}
          />
        </div>
        <div className="pages-form-box--item">
          <SwitchBtn
            activeTxt={t("active")}
            isActive={!!payload?.isActive}
            handleClick={() =>
              handleData("isActive", !(payload?.isActive ?? false))
            }
            disabled={readOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default PagesSeoMainTab;
